import { environment } from "@environment";
import { EMBED_SHELL_PATH } from "../constants";

/** URL-safe base64 of the UTF-8 bytes (no padding), matching the shell's decoder. */
export const encodeEmbedPayload = (html: string): string => {
  const bytes = new TextEncoder().encode(html);
  let bin = "";
  for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

/**
 * Builds the shell URL for a snippet. The HTML travels in the fragment, so it is
 * never sent to the assets server and never cached by the CDN.
 */
export const getEmbedShellUrl = (html: string): string =>
  `https://${environment.assetsBucket}${EMBED_SHELL_PATH}#${encodeEmbedPayload(html)}`;
